import { Plus, Trash2 } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

const TYPES = { text: "نص", number: "رقم", date: "تاريخ", select: "قائمة اختيارات" };

export const EmployeeFieldsSettings = ({ form, setForm }) => {
  const fields = form.employee_custom_fields || [];
  const set = (next) => setForm({ ...form, employee_custom_fields: next });
  const patch = (i, p) => set(fields.map((f, j) => (j === i ? { ...f, ...p } : f)));
  return (
    <div className="space-y-3 rounded-xl border border-slate-200 p-3 sm:col-span-2" data-testid="employee-fields-settings">
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="contract-alert-days">التنبيه قبل انتهاء عقد الموظف بـ (أيام)</Label>
          <Input id="contract-alert-days" type="number" min={1} max={365} data-testid="contract-alert-days-input"
            value={form.contract_alert_days ?? 60}
            onChange={(e) => setForm({ ...form, contract_alert_days: Math.min(365, Math.max(1, parseInt(e.target.value || "60", 10))) })} />
          <p className="text-xs text-slate-400">مثلاً 60 أو 90 يوماً — يظهر العقد في «وثائق تحتاج انتباهك» عند اقترابه.</p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-sm font-semibold text-slate-700">خانات إضافية في ملف الموظف</p>
        <button type="button" data-testid="emp-field-add" onClick={() => set([...fields, { key: `cf_${Date.now().toString(36)}`, label: "", type: "text", options: [] }])}
          className="inline-flex items-center gap-1 rounded-lg border border-blue-200 bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-100">
          <Plus className="h-3.5 w-3.5" /> إضافة خانة
        </button>
      </div>
      {fields.length === 0 && <p className="text-xs text-slate-400">لا توجد خانات إضافية بعد.</p>}
      {fields.map((f, i) => (
        <div key={f.key} className="flex flex-wrap items-center gap-2" data-testid={`emp-field-row-${i}`}>
          <Input data-testid={`emp-field-label-${i}`} value={f.label} placeholder="اسم الخانة" onChange={(e) => patch(i, { label: e.target.value })} className="h-9 w-44" />
          <select data-testid={`emp-field-type-${i}`} value={f.type} onChange={(e) => patch(i, { type: e.target.value })} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm">
            {Object.entries(TYPES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          {f.type === "select" && (
            <Input data-testid={`emp-field-options-${i}`} value={(f.options || []).join("، ")} placeholder="الخيارات مفصولة بفاصلة"
              onChange={(e) => patch(i, { options: e.target.value.split(/[,،]/).map((x) => x.trim()).filter(Boolean) })} className="h-9 flex-1 min-w-[160px]" />
          )}
          <button type="button" data-testid={`emp-field-del-${i}`} onClick={() => set(fields.filter((_, j) => j !== i))} className="rounded-lg p-1.5 text-rose-500 hover:bg-rose-50">
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
